import { Badge, Button, Form, Space, Tag } from "antd";
import { UserInfoContext } from "Context/CommonContext";
import { DRS_INITIAL_DATE, useDRSContext } from "Pages/DRS/Context/DRSContext";
import AdvancedFilters, {
  AdvancedFilterValues,
  INITIAL_STATUS,
} from "Pages/DRS/DRSFilter/DRSAdvancedFilters";
import { returnLabel } from "Pages/DRS/Utils/utils";
import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import { FilterOutlined, ClearOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { getCurrentMonthYear } from "Pages/DRS/DRSTabs/Dashboard/useDashboardFilter";
import dayjs from "dayjs";
import { deepCopy } from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizManualPickQuestions/components/PickQuestionUtil";
const StyledDiv = styled.div`
  display: flex;
  gap: 8px;
  max-width: 400px;
  overflow-x: auto;
  align-items: center;

  /* Hide scrollbar but keep scroll functionality */
  &::-webkit-scrollbar {
    height: 0px;
    display: none;
  }
`;

const DSRFilterHeader = ({ tabIndex }: any) => {
  const {
    setDSRFilters,
    DSRFilters,
    isQuestionSessionStarted,
    setPagination,
    drsDashboardFilters,
    individualFacultyFilters,
    setIndividualFacultyFilters,
    setDrsDashboardFilters,
    initialIndividualFacultyFilters,
    setPaginationDRSFilter,
  }: any = useDRSContext();
  const [form] = Form.useForm();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { screen }: any = useWindowSize();
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  const { pathname } = location;
  const isIndividualFaculty = pathname.includes("/DRS/faculty/");

  const FILTERS = isIndividualFaculty
    ? individualFacultyFilters
    : drsDashboardFilters;
  useEffect(() => {
    form.setFieldsValue({
      dateRange: DRS_INITIAL_DATE,
    });
  }, [DRS_INITIAL_DATE]);
  const handleApply = (filters: AdvancedFilterValues) => {
    if (tabIndex == "0") {
      myBucketFilters(filters);
    } else if (tabIndex == "1") {
      dashboardFilters(filters);
    }
  };
  const myBucketFilters = (filters: any) => {
    const formFilters: any = {
      ...DSRFilters,
      ...filters,
    };
    const values = form.getFieldValue("dateRange");

    if (values) {
      const startDate = values[0].format("YYYY-MM-DD");
      const endDate = values[1].format("YYYY-MM-DD");
      formFilters["startDate"] = startDate;
      formFilters["endDate"] = endDate;
    }
    delete formFilters.dateRange;
    setDSRFilters(formFilters);
    setOpen(false);
  };
  const dashboardFilters = (filters: AdvancedFilterValues) => {
    const formFilters: any = {
      ...FILTERS,
      ...filters,
    };
    const values = form.getFieldValue("dateRange");
    if (values) {
      const startDate = values[0].format("YYYY-MM-DD");
      const endDate = values[1].format("YYYY-MM-DD");
      formFilters["startDate"] = startDate;
      formFilters["endDate"] = endDate;
    }
    const date = formFilters["yearMonthStart"];
    if (date && Array.isArray(date)) {
      formFilters["yearMonthStart"] = date[0].format("YYYY-MM");
      formFilters["yearMonthEnd"] = date[1].format("YYYY-MM");
    }
    const commonFilters = {
      streamIds: formFilters.streamIds,
      subjectIds: formFilters.subjectIds,
      yearMonthStart: formFilters.yearMonthStart,
      yearMonthEnd: formFilters.yearMonthEnd,
    };

    setIndividualFacultyFilters((prev: any) => ({
      ...prev,
      ...formFilters,
    }));
    setDrsDashboardFilters((prev: any) => ({
      ...prev,
      ...commonFilters,
    }));
    setOpen(false);
  };
  const filters: any = deepCopy(removeEmptyFields(DSRFilters));
  if (filters["dateRange"]) {
    const { startDate, endDate } = filters["dateRange"];
    filters["startDate"] = startDate?.replace(/\//g, "-");
    filters["endDate"] = endDate?.replace(/\//g, "-");
    delete filters.dateRange;
  }
  const getFilterLength = () => {
    let count = Object.keys(filters).length;
    if (filters["startDate"] || filters["endDate"]) {
      count =
        count - (filters["startDate"] ? 1 : 0) - (filters["endDate"] ? 1 : 0);
      if (filters["dateRange"] || filters["startDate"]) count += 1;
    }
    if (filters["isSolvedByMe"] && filters["facultyId"]) {
      count -= 1;
    }
    return count;
  };
  const filterLength = getFilterLength();
  const resetHandler = () => {
    if (tabIndex == "0") {
      resetHandler1();
    } else if (tabIndex == "1") {
      resetHandler2();
    }
  };
  const resetHandler1 = () => {
    React.startTransition(() => {
      setPagination((prev: any) => ({ ...prev, current: 1 }));
      setDSRFilters({
        statuses: INITIAL_STATUS,
        dateRange: DRS_INITIAL_DATE,
      });
    });

    form.resetFields();
    form.setFieldsValue({
      dateRange: DRS_INITIAL_DATE,
    });
  };
  const resetHandler2 = () => {
    console.log("resetHandler");
    const defaultDate = getCurrentMonthYear();
    const resetState = isIndividualFaculty
      ? initialIndividualFacultyFilters
      : {
          yearMonthStart: defaultDate,
          yearMonthEnd: defaultDate,
        };

    const commonResetState = {
      yearMonthStart: resetState.yearMonthStart || defaultDate,
      yearMonthEnd: resetState.yearMonthEnd || defaultDate,
      streamIds: resetState.streamIds || undefined,
      subjectIds: resetState.subjectIds || undefined,
    };

    React.startTransition(() => {
      setPaginationDRSFilter((prev: any) => ({ ...prev, current: 1 }));
      setIndividualFacultyFilters((prev: any) => ({
        ...prev,
        ...commonResetState,
        facultyId: isIndividualFaculty ? prev.facultyId : undefined,
      }));
      setDrsDashboardFilters((prev: any) => ({
        ...prev,
        ...commonResetState,
      }));
    });

    form.resetFields();
    form.setFieldsValue(
      isIndividualFaculty && resetState.yearMonthStart
        ? {
            ...resetState,
            yearMonthStart: [
              dayjs(resetState.yearMonthStart),
              dayjs(resetState.yearMonthEnd),
            ],
          }
        : {
            yearMonthStart: [dayjs(defaultDate), dayjs(defaultDate)],
          }
    );
  };
  const getLabel = (arr: any[], key: string) => {
    if (arr.length === 0) return "";
    return arr
      .map((item) => {
        return returnLabel(userInfo, key, item);
      })
      .join(", ");
  };
  const isDestop = ["xxl", "xl", "lg"].includes(screen);
  return (
    <div className="d-flex justify-between items-center gap-3">
      {isQuestionSessionStarted ? null : (
        <StyledDiv>
          {filterLength > 0 && ["xxl", "xl", "lg"].includes(screen) && (
            <>
              {Object.keys(filters).map((ele: any) => {
                if (ele === "endDate" || ele === "yearMonthEnd") return null;

                if (ele === "startDate") {
                  const s = filters.startDate;
                  const e = filters.endDate;
                  if (!s && !e) return null;
                  return (
                    <Tag
                      style={{
                        textAlign: "center",
                        textTransform: "capitalize",
                      }}
                      key="dateRange"
                    >
                      {s && e ? `${s} ~ ${e}` : s || e}
                    </Tag>
                  );
                }

                if (
                  !filters[ele]?.length &&
                  ele !== "isSolvedByMe" &&
                  ele !== "yearMonthStart"
                )
                  return null;
                if (
                  !filters[ele]?.length &&
                  ele !== "isSolvedByMe" &&
                  ele !== "yearMonthStart"
                )
                  return null;
                return (
                  <Tag
                    style={{
                      textAlign: "center",
                      textTransform: "capitalize",
                    }}
                    key={ele}
                  >
                    {ele === "statuses"
                      ? (filters[ele] as string[]).join(", ")
                      : ele === "streamIds"
                      ? getLabel(filters[ele] as any[], "userStreams")
                      : ele === "subjectIds"
                      ? getLabel(filters[ele] as any[], "subjectsListing")
                      : ele === "isSolvedByMe"
                      ? "Solved by Me"
                      : ele === "yearMonthStart"
                      ? `${filters["yearMonthStart"]} - ${filters["yearMonthEnd"]}`
                      : filters[ele]}
                  </Tag>
                );
              })}
            </>
          )}
        </StyledDiv>
      )}
      {isQuestionSessionStarted ? null : (
        <Space>
          <Button
            size={isDestop ? "middle" : "small"}
            icon={!isDestop && <ClearOutlined />}
            onClick={resetHandler}
          >
            {isDestop && "Reset"}
          </Button>
          <Badge count={filterLength ? filterLength : 0}>
            <Button
              size={isDestop ? "middle" : "small"}
              icon={!isDestop ? <FilterOutlined /> : null}
              type="primary"
              onClick={() => setOpen(true)}
            >
              {isDestop && "Filters"}
            </Button>
          </Badge>
        </Space>
      )}

      <AdvancedFilters
        form={form}
        open={open}
        onClose={() => setOpen(false)}
        onApply={handleApply}
        onReset={resetHandler}
        type={tabIndex == "1" ? "drsDashboard" : "drsBucket"}
      />
    </div>
  );
};

export default DSRFilterHeader;
